// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1QYnx","legacyBtn":"MutateMid_legacyBtn__1VgLt"};